/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDrs401kHist.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/drs-401k-hist";

export class AutogenModelDrs401kHist<RowType extends ModelRow> extends Endpoint<RowType, RowDrs401kHistFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDrs401kHist extends ModelRow<RowDrs401kHistFields> {
	constructor(values?: Partial<RowDrs401kHistFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDrs401kHistFields {
	check_number: string;
	company_id: string;
	contrib_type: string;
	contribution: number;
	contribution_c: string;
	contribution_d: Date;
	contribution_n: number;
	contribution_r: number;
	deduction_date: Date;
	deduction_id: string;
	fund_id: string;
	id: string;
	is_void: string;
	matching_amount: number;
	matching_amount_c: string;
	matching_amount_d: Date;
	matching_amount_n: number;
	matching_amount_r: number;
	payee_id: string;
	post_key: string;
	post_module: string;
	sequence: number;
	void_date: Date;
}

